import React, { memo } from "react";
import { Message } from "react-message-context";

const FeedbackHeader = memo(() => {
  return (
    <>
      <h2>
        <Message id="feedback.header" />
      </h2>
      <p>
        <Message id="feedback.body" />
      </p>
    </>
  );
});

export default FeedbackHeader;
